export default __webpack_public_path__ + "static/media/binance.6bae77c6.svg";